import { render, staticRenderFns } from "./cabinet-service-table.vue?vue&type=template&id=316454d6"
import script from "./cabinet-service-table.vue?vue&type=script&lang=ts"
export * from "./cabinet-service-table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports